import React, { PureComponent } from 'react';
import Spinner from 'ak-spinner';

export default class TabbedComponents extends PureComponent {
  render(elem) {
    const { components, row: Row, search, header: Header, extraProps = {} } = this.props;
    if (!Row || !components || !components.length) return <Spinner />;
    return (
      <div>
        { Header ? <Header {...extraProps} /> : <span /> }
        {
          components
            .filter(component => component.name.match(search))
            .map(tabComponent => (
              <Row key={tabComponent.name} component={tabComponent} {...extraProps} />
            ))
        }
      </div>
    );
  }
};



// WEBPACK FOOTER //
// ./src/components/TabbedComponents.jsx